var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.items && _vm.showMenuItem(_vm.item)
    ? _c(
        "v-list-group",
        {
          key: _vm.item.href,
          attrs: { group: _vm.item.group },
          model: {
            value: _vm.item.startOpen,
            callback: function($$v) {
              _vm.$set(_vm.item, "startOpen", $$v)
            },
            expression: "item.startOpen"
          }
        },
        [
          _c(
            "v-list-tile",
            {
              staticClass: "v-menu-item",
              class: _vm.itemClass,
              attrs: {
                slot: "activator",
                target: _vm.item.target,
                href: _vm.item.href,
                title: _vm.item.title
              },
              slot: "activator"
            },
            [
              _c(
                "v-list-tile-action",
                [_c("v-icon", [_vm._v(" " + _vm._s(_vm.item.icon))])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _vm._v(" " + _vm._s(_vm.item.title))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.item.items, function(subItem) {
            return _vm.showMenuItem(subItem)
              ? _c(
                  "v-list-tile",
                  {
                    key: subItem.href,
                    staticClass: "v-menu-item",
                    class: _vm.itemClass,
                    attrs: { ripple: "", disabled: subItem.disabled },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.nav(subItem)
                      }
                    }
                  },
                  [
                    _c("app-v-menu", {
                      key: subItem.href,
                      attrs: {
                        item: subItem,
                        navigateFn: _vm.navigateFn,
                        itemClass: _vm.itemClass,
                        showIcon: false,
                        showMenuItemFn: _vm.showMenuItem
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          })
        ],
        2
      )
    : _vm.item.header && _vm.showMenuItem(_vm.item)
    ? _c("v-subheader", { key: _vm.item.href }, [
        _vm._v(" " + _vm._s(_vm.item.header))
      ])
    : _vm.item.divider && _vm.showMenuItem(_vm.item)
    ? _c("v-divider", { key: _vm.item.href })
    : _vm.showMenuItem(_vm.item)
    ? _c(
        "v-list-tile",
        {
          key: _vm.item.href,
          staticClass: "v-menu-item",
          class: _vm.itemClass,
          attrs: {
            target: _vm.item.target,
            href: _vm.item.href,
            ripple: "",
            disabled: _vm.item.disabled,
            title: _vm.item.title
          }
        },
        [
          _c(
            "v-list-tile-action",
            [_c("v-icon", [_vm._v(" " + _vm._s(_vm.item.icon) + " ")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile-content",
            [
              _c("v-list-tile-title", [
                _vm._v(" " + _vm._s(_vm.item.title) + " ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.item.subAction
            ? _c(
                "v-list-tile-action",
                [
                  _c("v-icon", { staticClass: "success--text" }, [
                    _vm._v(" " + _vm._s(_vm.item.subAction))
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1de25561", { render: render, staticRenderFns: staticRenderFns })
  }
}